import { css } from "@emotion/react";
import { useMemo } from "react";

export const useGridLayout = (
  columns?: { columnRatio?: number }[],
  options?: { hasSelectColumn?: boolean; hasActionsColumn?: boolean },
) => {
  const hasSelectColumn = options?.hasSelectColumn ?? false;
  const hasActionsColumn = options?.hasActionsColumn ?? false;
  const style = useMemo(() => {
    if (columns === undefined) {
      return false;
    }

    const hasColumnRatio = columns.some(
      (item) => item.columnRatio !== undefined,
    );

    if (hasColumnRatio === false) {
      return undefined;
    }

    const totalRatio = columns.reduce((prev, current) => {
      if (current.columnRatio === undefined) {
        return prev;
      }
      return prev + current.columnRatio;
    }, 0);

    const columnsTemplate = columns.reduce((prev, current) => {
      if (current.columnRatio === undefined) {
        return `${prev} auto`;
      }
      return `${prev} ${Math.floor(
        (current.columnRatio / totalRatio) * 100,
      )}fr`;
    }, "");

    const gridTemplateColumns = [
      hasSelectColumn ? "56px" : "",
      columnsTemplate,
      hasActionsColumn ? "auto" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return css`
      display: grid;
      grid-template-columns: ${gridTemplateColumns};

      thead,
      thead tr {
        display: contents;
      }

      tbody,
      tbody tr {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;
      }
    `;
  }, [columns, hasSelectColumn, hasActionsColumn]);

  return style;
};
